var _path, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2261 3.25H8.22607C5.05607 3.25 2.47607 5.83 2.47607 9V15C2.47607 18.17 5.05607 20.75 8.22607 20.75H16.2261C19.3961 20.75 21.9761 18.17 21.9761 15V9C21.9761 5.83 19.3961 3.25 16.2261 3.25ZM20.4761 15C20.4761 17.34 18.5661 19.25 16.2261 19.25H8.22607C5.88607 19.25 3.97607 17.34 3.97607 15V9C3.97607 6.66 5.88607 4.75 8.22607 4.75H16.2261C18.5661 4.75 20.4761 6.66 20.4761 9V15Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.27734,
    y: 7.79785,
    width: 11.8975,
    height: 1.91128,
    rx: 0.95564
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.27734,
    y: 11.0444,
    width: 11.8975,
    height: 1.91128,
    rx: 0.95564
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.27734,
    y: 14.2905,
    width: 11.8975,
    height: 1.91128,
    rx: 0.95564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.bd6bf1aabe1cd75a92cfcaf3799441d9.svg";
export { ForwardRef as ReactComponent };